
import React from "react";
import Logo from "../../Imagens/LOGOTIPO 12.png";

function Banner() {
  return (
    <section id="banner" className="hero">
      <div className="hero-bg hero-bg-1" />
      <div className="hero-bg hero-bg-2" />

      <div className="container hero-container">
        <div className="hero-conteudo">
          <span className="etiqueta">
            <span className="status-ponto" />
            TECNOLOGIA FEITA PARA O SEU NEGÓCIO
          </span>

          <h1>
            Sua ideia merece uma
            <span className="texto-destaque"> solução extraordinária.</span>
          </h1>

          <p className="hero-descricao">
            Desenvolvemos sistemas, aplicativos e soluções digitais
            personalizadas para transformar desafios em oportunidades
            para sua empresa.
          </p>

          <div className="hero-acoes">
            <a href="#contato" className="btn-principal">
              Vamos tirar sua ideia do papel
              <span aria-hidden="true"> ↗</span>
            </a>

            <a href="#solucoes" className="btn-secundario">
              Conheça nossas soluções
            </a>
          </div>

          <div className="hero-diferenciais">
            <div>
              <span className="diferencial-icone">✦</span>
              <span>Soluções sob medida</span>
            </div>

            <div>
              <span className="diferencial-icone">⌘</span>
              <span>Tecnologia inteligente</span>
            </div>

            <div>
              <span className="diferencial-icone">↗</span>
              <span>Foco no seu negócio</span>
            </div>
          </div>
        </div>

        <div className="hero-visual">
          <div className="hero-imagem">
            <div className="hero-circulo" />
            <img src={Logo} alt="Soluções digitais iSolution" />

            <div className="flutuante flutuante-topo">
              <span className="flutuante-icone">{"</>"}</span>
              <div>
                <strong>Desenvolvimento</strong>
                <small>Do seu jeito</small>
              </div>
            </div>

            <div className="flutuante flutuante-baixo">
              <span className="flutuante-icone">✦</span>
              <div>
                <strong>Ideias em ação</strong>
                <small>Soluções personalizadas</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="hero-rodape">
        <span>INOVAÇÃO</span>
        <span className="hero-linha" />
        <span>DESENVOLVIMENTO</span>
        <span className="hero-linha" />
        <span>RESULTADOS</span>
      </div>
    </section>
  );
}

export default Banner;
